import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClientXsrfModule} from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap';
import {NgPipesModule} from 'ngx-pipes';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import {DjangoSessionAuthenticationService} from './shared/';
import {AddApiUrlInterceptor, WithCredentialsInterceptor, HttpXsrfInterceptorMod} from './shared/';
import { OffersComponent } from './offers/offers.component';
import { AccountComponent } from './account/account.component';
import {CollectorService} from './collector/collector.service';
import {ProvincesService} from './provinces/provinces.service';
import {FchartalgoService} from './fchart/fchartalgo.service';
import { CoordService } from './captadores/coord.service';
import { BarchartService } from './offers/barchart.service';
import { OffersService } from './offers/offers.service';
import { GaugeService } from './offers/gauge.service';
import { BrujulaService } from './ubicacion/brujula.service';
import {GeoService} from './geo/geo.service';
import { StaticService } from './consulta/static.service';
import { ConsultaComponent } from './consulta/consulta.component';
import { UbicacionComponent } from './ubicacion/ubicacion.component';
import { OpcionesComponent } from './opciones/opciones.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CaptadoresComponent } from './captadores/captadores.component';
import {GeneralMessages} from './shared/services';
import {AcvmessagingService} from './shared_services/acvmessaging.service';
import { ModalComponent } from './modal/modal.component';
import { TestModalComponent } from './test-modal/test-modal.component';
import { SorterPipe } from './sorter.pipe';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    OffersComponent,
    AccountComponent,
    ConsultaComponent,
    UbicacionComponent,
    OpcionesComponent,
    HeaderComponent,
    FooterComponent,
    CaptadoresComponent,
    ModalComponent,
    TestModalComponent,
    SorterPipe
  ],
  imports: [
    BrowserModule,
    NgPipesModule,
    FormsModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'csrftoken',
    }),
    ModalModule.forRoot()
  ],
  providers: [
    DjangoSessionAuthenticationService,
    {provide: HTTP_INTERCEPTORS, useClass: AddApiUrlInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: WithCredentialsInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptorMod, multi: true},
    CollectorService,
    ProvincesService,
    FchartalgoService,
    OffersService,
    GaugeService,
    BarchartService,
    CoordService,
    BrujulaService,
    GeoService,
    StaticService,
    {provide: GeneralMessages, useClass: AcvmessagingService},
  ],
  bootstrap: [AppComponent],
  entryComponents: [ModalComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts